import { render } from "./003-XiangShanPage.vue?vue&type=template&id=51691eab&scoped=true"
import script from "./003-XiangShanPage.vue?vue&type=script&lang=js"
export * from "./003-XiangShanPage.vue?vue&type=script&lang=js"

import "@/assets/css/news.css?vue&type=style&index=0&id=51691eab&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51691eab"]])

export default __exports__